// A product chosen only in the buy section is still an authoritative Shopify
// price source. Reuse its server-formatted single-handset price, never a bundle.
(() => {
  function sync(root = document) {
    const prices = root.querySelectorAll('[data-comparison-inherit]');
    const product = document.querySelector('[data-offline-unit-price-money][data-mapped="true"]');
    if (!product || !product.dataset.offlineUnitPriceMoney) return;
    prices.forEach(slot => {
      if (slot.dataset.priceCurrency !== product.dataset.offlineUnitPriceCurrency) return;
      slot.textContent = product.dataset.offlineUnitPriceMoney;
      slot.dataset.priceSource = 'shopify-section';
      slot.dataset.productId = product.dataset.productId;
      slot.parentElement.querySelector('.cmpc__preview-note')?.remove();
    });
  }
  sync();
  document.addEventListener('shopify:section:load', () => sync());
})();
